import { render, staticRenderFns } from "./CreateGuildModal.vue?vue&type=template&id=023dfb58&"
import script from "./CreateGuildModal.vue?vue&type=script&lang=js&"
export * from "./CreateGuildModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports